import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvConfiguration, EnvConfigurationJSON } from '@core/models/env-configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class EnvConfigurationService {
  public env: EnvConfiguration;
  private readonly configUrl = 'config/config.json';
  private http: HttpClient;

  constructor(private handler: HttpBackend) {
    // HttpClient instance with a specific handler to avoid app interceptors --> cyclic dependency
    this.http = new HttpClient(this.handler);
  }

  public load(): Promise<void> {
    return this.http
      .get<EnvConfigurationJSON>(this.configUrl)
      .toPromise()
      .then(config => {
        this.env = {
          baseUrl: config.baseUrl,
          drupalBaseUrl: config.drupalBaseUrl,
          e2HelpDeskUrl: config.e2HelpDeskUrl,
          e5xMaxFileSize: parseInt(config.e5xMaxFileSize),
          e5zMaxFileSize: parseInt(config.e5zMaxFileSize),
          e5xMaxFileNumber: parseInt(config.e5xMaxFileNumber),
          e5zMaxFileNumber: parseInt(config.e5zMaxFileNumber),
          disableViewActionControl: config.disableViewActionControl === 'true',
          recaptchaV3SiteKeyValue: config.recaptchaV3SiteKeyValue,
          e2ClientConfigJSONVersion: config.e2ClientConfigJSONVersion
        };
      });
  }
}
